import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import type SubjectMemberView from '@UI/Store/Subjects/Views/SubjectMemberView';

/** The members of one dossier. */
class SubjectMembersListView {
	readonly typeKey: string;
	readonly subjectId: number;
	readonly members: readonly SubjectMemberView[];

	constructor(typeKey: string, subjectId: number, members: readonly SubjectMemberView[]) {
		this.typeKey = typeKey;
		this.subjectId = subjectId;
		this.members = members;

		Object.freeze(this);
	}

	isFor(subject: SubjectAddress): boolean {
		return this.typeKey === subject.typeKey && this.subjectId === subject.subjectId;
	}

	hasMember(userId: number): boolean {
		return this.members.some((member) => member.userId === userId);
	}
}

export default SubjectMembersListView;
